import React from 'react';

import PropTypes from 'prop-types';

import Button from '../components/buttons/Button';

import './InboxHeader.scss';

const InboxHeader = (props) => {
    const { closeInboxHandler } = props;

    const CloseButton = (
        <div className="close-inbox">
            <Button onClickFn={closeInboxHandler}>
                <span>Close</span>
            </Button>
        </div>
    );

    return (
        <div className="InboxHeader">
            <h2 className="inbox-title">Unsorted</h2>
            {closeInboxHandler ? CloseButton : null}
        </div>
    );
};

InboxHeader.propTypes = {
    gridSize: PropTypes.number,
    closeInboxHandler: PropTypes.func,
    className: PropTypes.string,
};

export default InboxHeader;
